import i18next, { ThirdPartyModule } from 'i18next';

import configs, { EProjectPlatform } from '@aqx-core/common/configs';

import { overloadTranslationOptionHandler, resolveMultipleTranslation } from './src/plugins';
import { ILanguage, ILanguageResource } from './src/types';

export * from './src/types';

export interface IBaseAppLanguageManagerParams<T extends string> {
  languages: ILanguage<T>[];
  resources: Record<T, ILanguageResource>;
  fallbackLanguage: ILanguage<T>;
  initReactI18nextInstance: ThirdPartyModule;
}

abstract class BaseAppLanguageManager<T extends string> {
  private params: IBaseAppLanguageManagerParams<T>;

  constructor(params: IBaseAppLanguageManagerParams<T>) {
    this.params = {
      ...params
    };
  }

  init = (onFinish: () => void) => {
    if (!i18next.isInitialized) {
      const { initReactI18nextInstance, fallbackLanguage, resources } = this.params;

      i18next
        .use(initReactI18nextInstance)
        .use(resolveMultipleTranslation)
        .init(
          {
            ns: ['resource'],
            load: 'languageOnly',
            defaultNS: 'resource',
            fallbackLng: fallbackLanguage.value,

            debug:
              configs.platform === EProjectPlatform.WEB ? NODE_ENV === 'development' : configs.environment === 'dev',

            saveMissing: false,
            nsSeparator: false,
            keySeparator: false,
            interpolation: {
              escapeValue: false
            },
            overloadTranslationOptionHandler: overloadTranslationOptionHandler,
            resources
          },
          onFinish
        );
    }
  };

  getAllLanguages = () => {
    return this.params.languages;
  };

  public abstract setLanguagePreference(language: T): void;
}

export default i18next;

export { BaseAppLanguageManager };
